export const SELECT_NAME = 'Select';
export const SELECT_ROLE = 'select';
export const SELECT_SIZES = { default: 'default', lg: 'lg' } as const;
